import React from 'react'
import PropTypes from 'prop-types'

import './styles.scss'

const MainHeader = ({ headingText, aboutText }) => (
  <header className="main-header" title="Daniel Rahman">
    <div className="main-header--position">
      <h1 className="main-header__heading">{headingText}</h1>
      <p className="main-header__about">{aboutText}</p>
    </div>
  </header>
)

MainHeader.propTypes = {
  headingText: PropTypes.string.isRequired,
  aboutText: PropTypes.string.isRequired,
}

export default MainHeader
